import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const CircularDetailsLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'CircularDetails' */ './components/CircularDetails'
		)
);

export default (store) => {
	return {
		path: ':circularId',
		element: <AsyncLoading component={<CircularDetailsLazy />} />,
	};
};
